// To see this message, add the following to the `<head>` section in your
// views/layouts/application.html.erb
//
//    <%= vite_client_tag %>
//    <%= vite_javascript_tag 'application' %>

// If using a TypeScript entrypoint file:
//     <%= vite_typescript_tag 'application' %>
//
// If you want to use .jsx or .tsx, add the extension:
//     <%= vite_javascript_tag 'application.jsx' %>

// Example: Load Rails libraries in Vite.
//
// import * as Turbo from '@hotwired/turbo'
// Turbo.start()
//
// import ActiveStorage from '@rails/activestorage'
// ActiveStorage.start()
//
// // Import all channels.
// const channels = import.meta.globEager('./**/*_channel.js')

// Example: Import a stylesheet in app/frontend/index.css
// import '~/index.css'

// Libs
import '@hotwired/turbo-rails'
// Turbo Drive's asset-tracking (data-turbo-track on the <title>, which changes every
// page) was forcing a full reload on EVERY navigation — after first doing a wasted
// AJAX fetch (the orange progress bar). The legacy jQuery pages rely on full page
// loads anyway, so turn Drive off: links/forms become single normal page loads
// (no bar, no double fetch). Turbo Frames (used on settings pages) keep working.
if (window.Turbo) window.Turbo.session.drive = false
// With Drive off, data-turbo-method links would do a plain GET; this restores
// them as real form submissions (logout, archive, delete, etc.).
import '~/javascripts/turbo_method_shim'
import 'bootstrap'
import '@popperjs/core'
import "@fortawesome/fontawesome-free/css/all.css";

// import 'simple-datatables'

// Styles
// import '~/stylesheets/argon/index.css'
// import '@fortawesome/fontawesome-free/css/all.css'
// import '~/stylesheets/shared.scss'
// import '~/stylesheets/inventory.scss'

// Javascripts
import '~/javascripts/messenger'
import '~/javascripts/controllers'
import '~/javascripts/argon'
import '~/javascripts/vue'
import '~/javascripts/inventory'
import '~/javascripts/deal'
import '~/javascripts/lead'
import '~/javascripts/billing'
import '~/javascripts/service_contract'
import '~/javascripts/form_folder'
import '~/javascripts/credit_application'

// Universal, idempotent widget-initialization layer. Owns every NON-Stimulus form widget
// (app-wide flatpickr `.date-input`, legacy `select.combobox`, `.currency_decimal` display
// formatting) and (re)initializes them across turbo:load, turbo:frame-load, turbo-STREAM
// replacements, and jQuery add_child inserts — closing the "widget doesn't init on
// dynamically-added or re-rendered content" class of bug. The module self-wires all of those
// arrival paths on import (see app/frontend/javascripts/widget_init.js); this import is the
// single place that used to hand-roll the `.date-input` flatpickr hook.
import '~/javascripts/widget_init'
